import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-pl",
  "use": "icon-icon-pl-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-pl\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#fff\" d=\"M512 512H0V0h512z\" />\n    <path fill=\"#dc143c\" d=\"M512 512H0V256h512z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol